export const PRODUCT_PAGE_TITLE_PRODUCT_ICON_STYLE_PROPS = {
  marginInlineEnd: '300',
  blockSize: '32px',
  inlineSize: '32px'
};
export const MERCH_CARD_PRODUCT_ICON_STYLE_PROPS = {
  blockSize: '24px',
  marginInlineEnd: '200',
  responsive: false
};